"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var responsive_1 = require("@dynamynd/responsive");

var react_1 = __importDefault(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

exports.NotificationsContainerView = styled_components_1.default(function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      rest = __rest(_a, ["activeBreakpoint"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: fixed;\n    top: ", "px;\n    right: ", "px;\n    z-index: 999;\n"], ["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    position: fixed;\n    top: ", "px;\n    right: ", "px;\n    z-index: 999;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return setContainerPosition(activeBreakpoint);
}, function (_a) {
  var activeBreakpoint = _a.activeBreakpoint;
  return setContainerPosition(activeBreakpoint);
});

function setContainerPosition(activeBreakpoint) {
  return responsive_1.isSmall(activeBreakpoint) ? 12 : 32;
}

exports.NotificationContainer = styled_components_1.default(function (_a) {
  var borderColor = _a.borderColor,
      activeBreakpoint = _a.activeBreakpoint,
      width = _a.width,
      rest = __rest(_a, ["borderColor", "activeBreakpoint", "width"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    z-index: 999;\n    min-width: 320px;\n    width: ", ";\n    max-width: ", ";\n    max-height: 44px;\n    margin-bottom: 8px;\n    border-radius: 4px;\n    border-width: 1px;\n    border-color: ", ";\n    background-color: white;\n"], ["\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    z-index: 999;\n    min-width: 320px;\n    width: ", ";\n    max-width: ", ";\n    max-height: 44px;\n    margin-bottom: 8px;\n    border-radius: 4px;\n    border-width: 1px;\n    border-color: ", ";\n    background-color: white;\n"])), function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      width = _a.width;
  return setContainerWidth(activeBreakpoint, width);
}, function (_a) {
  var activeBreakpoint = _a.activeBreakpoint,
      width = _a.width;
  return setContainerMaxWidth(activeBreakpoint, width);
}, function (_a) {
  var borderColor = _a.borderColor;
  return borderColor;
});

function setContainerWidth(activeBreakpoint, width) {
  if (responsive_1.isSmall(activeBreakpoint)) {
    return width - 24 + "px";
  }

  return 'auto';
}

function setContainerMaxWidth(activeBreakpoint, width) {
  if (responsive_1.isSmall(activeBreakpoint)) {
    return width + "px";
  }

  return '420px';
}

exports.NotificationIconContainer = styled_components_1.default(function (_a) {
  var backgroundColor = _a.backgroundColor,
      rest = __rest(_a, ["backgroundColor"]);

  return react_1.default.createElement(react_native_1.View, __assign({}, rest));
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 44px;\n    height: 44px;\n    background-color: ", ";\n"], ["\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 44px;\n    height: 44px;\n    background-color: ", ";\n"])), function (_a) {
  var backgroundColor = _a.backgroundColor;
  return backgroundColor;
});
exports.NotificationText = styled_components_1.default(react_native_1.Text)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    max-height: 32px;\n    margin-left: 16px;\n    font-size: 14px;\n    color: ", ";\n"], ["\n    max-height: 32px;\n    margin-left: 16px;\n    font-size: 14px;\n    color: ", ";\n"])), function (props) {
  return props.theme.colors.dark;
});
exports.NotificationAction = styled_components_1.default(react_native_1.View)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    cursor: pointer;\n    margin: 0 10px 0 auto;\n"], ["\n    cursor: pointer;\n    margin: 0 10px 0 auto;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;